// Shared message descriptors for the expanded-polygon ("properties nearby")
// feature. Defined once so an identical string maps to a single translation
// key everywhere it renders, rather than duplicating the copy under separate
// keys per context.

// Subtext shown alongside the nearby carousel in both the low-results banner
// and the no-results (variant_a) page. {destination} is the searched region.
export const outsideDestinationSubtext = {
  id: 'search-results.properties-nearby.outside-destination-subtext',
  defaultMessage:
    'These properties are available and match your search but are outside of {destination}',
}
